export const showCompareAtPrice = (price: string, compareAtPrice: string) => {
  if (!Number(compareAtPrice)) return false

  return Number(price) < Number(compareAtPrice)
}
